import { EntityWithIdAndDescription } from 'src/types'

export const OperacionContraparteImporteFields = {
    ContraparteImporte: 'contraparteImporte'
} as const

export type OperacionContraparteImporteVista = EntityWithIdAndDescription & {
    [OperacionContraparteImporteFields.ContraparteImporte]: number
}

export const OperacionCorporateImporteFields = {
    CorporateImporte: 'corporateImporte'
} as const

export type OperacionCorporateImporteVista = EntityWithIdAndDescription & {
    [OperacionCorporateImporteFields.CorporateImporte]: number
}
